'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('workorder-ticket-show', {
      url: '/workorder/ticket/detail/:id',
      template: '<work-order-ticket-show></work-order-ticket-show>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/workorders/ticket-show/workorder-ticket-show.routes.js